import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type HblStatusState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: [];
  filterSearchData: any[];
  filterSearchDetailData: any[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  hblDetail: any[];
  hblDocDetail: any[];
  hblDocValidation: any;
  success: boolean;
};

const initialState: HblStatusState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  filterSearchDetailData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  hblDetail: [],
  hblDocDetail: [],
  hblDocValidation: {},
  success: false,
};

export const hblStatusSlice = createSlice({
  name: 'hblStatus',
  initialState,
  reducers: {
    filterHbl: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    filterHblSuccess: (state, action) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterHblDetail: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    filterHblDetailSuccess: (state, action) => {
      state.loading = false;
      state.filterSearchDetailData = action.payload?.records;
      state.success = false;
    },
    filterHblFailure: (state) => {
      state.loading = false;
    },
    getDetailHbl: (state, action) => {
      state.loading = true;
    },
    getDetailHblSuccess: (state, action) => {
      state.loading = false;
      state.hblDetail = action.payload;
    },
    getDetailHblFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    updateHbl: (state, action) => {
      state.loading = true;
      state.success = false;
    },
    updateHblSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateHblFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updateHblList: (state, action) => {
      state.loading = true;
      state.success = false;
    },
    updateHblListSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateHblListFailure: (state, action) => {
      state.loading = false;
      state.success = false;
    },
    getDetailHblDoc: (state, action) => {
      state.loading = true;
    },
    getDetailHblDocSuccess: (state, action) => {
      state.loading = false;
      state.hblDocDetail = action.payload;
    },
    getDetailHblDocFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    uploadHblDoc: (state, action) => {},
    deleteHblDoc: (state, action) => {},
    getHblDocValidation: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    getHblDocValidationSuccess: (state, action) => {
      state.loading = false;
      state.hblDocValidation = action.payload;
      state.success = false;
    },
    getHblDocValidationFailure: (state, action) => {
      state.loading = false;
    },
    cleanDataHbl: (state) => {
      state.hblDetail = [];
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
    uploadPortcastInfo: (state, action) => {},
  },
});

export const {
  filterHbl,
  filterHblDetail,
  filterHblSuccess,
  filterHblDetailSuccess,
  filterHblFailure,
  setLoadingExportExcel,
  getDetailHbl,
  getDetailHblSuccess,
  getDetailHblFailure,
  updateHbl,
  updateHblSuccess,
  updateHblFailure,
  updateHblList,
  updateHblListSuccess,
  updateHblListFailure,
  getDetailHblDoc,
  getDetailHblDocSuccess,
  getDetailHblDocFailure,
  uploadHblDoc,
  deleteHblDoc,
  getHblDocValidation,
  getHblDocValidationSuccess,
  getHblDocValidationFailure,
  cleanDataHbl,
  cleanData,
  uploadPortcastInfo,
} = hblStatusSlice.actions;

export default hblStatusSlice.reducer;
